import $ from 'jquery';
import init from './init';

$(init);
